import { PostPreview } from '../postPreview'
import { ButtonCreate } from '../buttonCreate'
import { useClube } from '../contextClube';
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { api } from '../../../../../services/api';
import { toast } from 'react-toastify';

import { Container } from './style';

export function PrimaryBanners() {
    const { 
            primaryBanners, 
            setModalTitleAndRoute, 
            loading ,
            deleteElement
    } = useClube()

    function handleClickCreateButton() {
        setModalTitleAndRoute({title: 'Banner Principal', route: '/createPrimaryBanner', create: 1})
    }

    function handleClickEditButton() {
        setModalTitleAndRoute({title: 'Banner Principal', route: '/updatePrimaryBanner', create: 0})
    }

    async function handleClickActiveButton(id, status) {
        const obj = {
            id,
            active: status
        }

        try{
            await api.patch('/activePrimaryBanner', obj,  {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }catch{
            toast.error('Algo deu errado, tente novamente')
        }
    }

    async function handleClickToDelete(id) {
        try{
            const response = await api.delete(`/deletePrimaryBanner/${id}`)
            
            const { success, message } = response.data

            if(success){
                toast.success(message)
                deleteElement('/deletePrimaryBanner', id)
            }
            else
                throw new Error(message)

        }catch(error){
            toast.error(error.message)
        }
    }

    return(
        <Container>
            <div className="title">
                <h2>Banners Principais</h2>
                <div />
            </div>

            {
                loading ?
                    <SpaceLoader colorLoader="#535352"/>
                :
                primaryBanners.map(banner => (
                    <PostPreview 
                        key={banner.id}
                        datas={banner}
                        handleClickEditButton={handleClickEditButton}
                        handleClickActiveButton={handleClickActiveButton}
                        handleClickToDelete={handleClickToDelete}
                    />
                ))
            }
            
            <ButtonCreate 
                handleClickCreateButton={handleClickCreateButton}
            />
        </Container>
    )
}
